import { CONDITION_STATUS, CONDITION_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueGetterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * conditionStatusの値からフィルタ用の文字列を生成する。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const conditionStatusFilterValueGetter = (params: ValueGetterParams) => {
  const value: string = params.getValue('conditionStatus');
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const filterValue: string | undefined = currentLang ? (currentLang.value === LANGUAGE.JA ? CONDITION_STATUS_JA[value] : CONDITION_STATUS[value]) : value;
  return filterValue;
};

export default conditionStatusFilterValueGetter;
